import React, { useState } from "react";
import { useStyles } from "./styles";
import { Box, IconButton, Typography, Button, CircularProgress, Modal, Tooltip } from "@material-ui/core";

import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import apiV2 from "../../../../api/api-client-v2";
import { toast } from "react-toastify";
import { formatDocumentNumber } from "../../../../utils/formatDocumentNumber";

export const CardUser = ({
  user,
  isPending,
  isApproved,
  handleShowModal,
  setCountChangeUser,
  setUserId,
  isReproved,
}) => {
  const classes = useStyles();
  const [isLoading, setIsloading] = useState(false)
  const [showModalResetPasswordOrResendInvite, setShowModalResetPasswordOrResendInvite] = useState(false)

  const labelCpfOrCnpj = user?.document_number?.length === 11 ? 'CPF' : user?.document_number?.length === 14 ? 'CNPJ' : 'CPF/CNPJ';

  const handleCloseModal = () => setShowModalResetPasswordOrResendInvite(false)

  const handleResetPasswordOrResendInvite = (id, email, action) => {
    setIsloading(true)
    apiV2.post(`users/signups/${id}/${action}`).then(() => {
      if (action !== 'reset-rejected'){
        toast.success(`E-mail enviado para ${email}!`)
      }
      handleCloseModal()
    })
    .catch(() => {
      toast.error(`Não foi possivel enviar o E-mail para ${email}!`)
    })
    .finally(() => {
      setIsloading(false)
      setCountChangeUser(previewState => previewState +1)
    })
  }

  return (
    <Box className={classes.container}>
      <Box className={classes.statusContainer}>
        <Box className={classes.statusInfo}>
          <Typography variant="body2">Status:</Typography>
          {isPending && <span className="badge">Pendente</span>}
          {isApproved && <span className="badge">Aprovado</span>}
          {isReproved && <span className="badge">Reprovado</span>}
        </Box>
        {!isReproved && (
          <>
          <Box className={classes.resetPass}>

            <Button
              variant="text"
              disabled={isLoading}
              onClick={() => setShowModalResetPasswordOrResendInvite('resend-invite')}
            >
              Reenviar Convite
            </Button>


            {!isPending &&
            <Button
              variant="text"
              disabled={isLoading}
              onClick={() => setShowModalResetPasswordOrResendInvite('reset-password')}
            >
              Resetar senha
            </Button>
            }
          </Box>
          </>
        )}
        {isReproved && (
           <Box className={classes.resetPass} >
           <Tooltip title='Reverter Reprovação' placement="top">
             <Button
              variant="text"
              disabled={isLoading}
               onClick={() => {
                 setUserId(user?.id)
                 setShowModalResetPasswordOrResendInvite("reset-rejected")
               }}
               >
               Reverter Reprovação
             </Button>
           </Tooltip>
         </Box>
        )}

      </Box>
      <Box className={classes.content}>
        <Box className={classes.nameContainer}>
          <Typography className={`${classes.nameText} ${classes.truncateText}`}>{user?.full_name}</Typography>
          <Typography style={{ fontSize: 12 }}>{
            user?.user_type === 'client' ? 'Cliente' : (user?.user_type === 'vendor' ? 'Fornecedor' : 'Transportadora')
          }</Typography>
        </Box>
        <Box className={classes.infoContainer}>
          <Box className={classes.firstColumn}>
            {user?.corporate_name && (
              <Box className={classes.info} style={{maxWidth:'200px'}}>
                <Typography className="label">Razão Social</Typography>
                <Typography className={`wrong ${classes.truncateText}`}>{user?.corporate_name}</Typography>
              </Box>
            )}
            <Box className={classes.info}>
              <Typography className="label">ID Logar</Typography>
              <Typography className="wrong">{user?.id}</Typography>
            </Box>
          </Box>
          <Box className={classes.secondColumn}>
            <Box className={classes.info}>
              <Typography className="label">E-mail</Typography>
              <Typography className="wrong">{user?.email}</Typography>
            </Box>
            <Box className={classes.info}>
              <Typography className="label">UF</Typography>
              <Typography className="wrong">{user?.state?.toUpperCase()}</Typography>
            </Box>
            <Box className={classes.info}>
              <Typography className="label">ID OKTA</Typography>
              <Typography className="wrong">{user?.login}</Typography>
            </Box>
          </Box>
          <Box className={classes.thirdColumn}>
            <Box className={classes.info}>
              <Typography className="label">
                {labelCpfOrCnpj}
              </Typography>
              <Typography className="wrong">
                {formatDocumentNumber(user?.document_number)}
              </Typography>
            </Box>
            <Box className={classes.info}>
              <Typography className="label">Cidade</Typography>
              <Typography className="wrong">{user?.city_name}</Typography>
            </Box>
          </Box>
          {!!isPending && (
            <Box className={classes.btn}>
              <Tooltip title='Aprovar' placement="top">

                <IconButton
                  onClick={() => {
                    setUserId(user?.id)
                    handleShowModal("approved")
                  }}
                  className="check"
                >
                  <CheckIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title='Reprovar' placement="top">
                <IconButton
                  onClick={() => {
                    setUserId(user?.id)
                    handleShowModal("reproved")
                  }}
                  className="close"
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </Box>
          )}

          {!!isApproved && (
            <Box className={classes.btn} />
          )}
        </Box>
      </Box>
      <Box>
      {isReproved && (
              <Box className={classes.info} style={{paddingTop:'20px'}}>
                <Typography className="label">Motivo de reprovação</Typography>
                <Typography className={`wrong ${classes.reasonDisapproval}`}>{user?.reason_disapproval ? user.reason_disapproval : '-'}</Typography>
              </Box>
            )}
      </Box>
      <Modal
        className={classes.modal}
        open={!!showModalResetPasswordOrResendInvite}
        onClose={handleCloseModal}
      >
        <Box className={classes.modalContainer}>
          <Typography className={classes.titleModal}>
            {}
             Deseja {showModalResetPasswordOrResendInvite === "resend-invite"
             ? "reenviar o convite?" : showModalResetPasswordOrResendInvite  === 'reset-rejected'
              ? 'Reverter reprovação?'
              : "resetar a senha?"}
          </Typography>
          <Typography className={classes.textodal}>
            {}
            {showModalResetPasswordOrResendInvite === "resend-invite"
              ? "Após a aprovação, o usuário receberá um e-mail com as instruções para a ativação da conta."
              : showModalResetPasswordOrResendInvite  === 'reset-rejected'
                ? 'Após reverter, o usuário retornará para aba "Pendentes" e estará sujeito à aprovação ou reprovação novamente.'
                : "Após a aprovação, o usuário receberá um e-mail com as instruções para redefinir sua senha."}
          </Typography>
          <Box className={classes.infoModalUserContainer}>
            <Box className={classes.infoModalUser}>
              <Typography className="label">
                {labelCpfOrCnpj}
              </Typography>
              <Typography className="wrong">{formatDocumentNumber(user?.document_number)}</Typography>
            </Box>
            <Box className={classes.infoModalUser}>
              <Typography className="label">Nome</Typography>
              <Typography className="wrong">{user?.full_name}</Typography>
            </Box>
            <Box className={classes.infinfoModalUser}>
              <Typography className="label">Razão Social</Typography>
              <Typography className="wrong">{user?.corporate_name ? user.corporate_name : '-'}</Typography>
            </Box>
          </Box>
          <Box className={classes.btnModal}>
            <Button
              className="cancel"
              variant="contained"
              size="large"
              onClick={handleCloseModal}
            >
              CANCELAR
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="large"
              disabled={isLoading}
              onClick={() => handleResetPasswordOrResendInvite(user?.id, user?.email, showModalResetPasswordOrResendInvite)}
            >
             {isLoading && <CircularProgress size={10} style={{ marginRight: 5 }} />} {showModalResetPasswordOrResendInvite === "resend-invite" ? "REENVIAR" : showModalResetPasswordOrResendInvite  === 'reset-rejected' ? 'REVERTER' : "RESETAR"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};
